import React, { memo, useCallback, useEffect, useState } from "react";
import { IMAGE_SRC, soundSrc } from "../../common/constants";
import { Icons } from "../Icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useClock } from "../../hooks/useClock";
import Switch from "./switch/Switch";
import { setRain, setStatusScene } from "../../store/features/scenesSlice";
import Control from "./Control/Control";
import { Slider, Stack } from "@mui/material";
import styled from "styled-components";
import Dropdown from "./menu/Dropdown";
import useClickOutSide from "../../hooks/useClickOutSide";
import { CASE, useAuthContext } from "../../context/useAuthContext";
const Header = () => {
  const { dispatch: dispatchAction, state } = useAuthContext();
  const date = useClock();
  const {
    show: showDropdown,
    setShow: setShowDropdown,
    menuRef,
    popupRef: dropdownRef,
  } = useClickOutSide();

  const dispatch = useDispatch();
  const currentScene = useSelector(
    (state: RootState) => state.scenes.currentScene
  );
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const [checked, setChecked] = useState<boolean>(false);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const isRain = useSelector((state: RootState) => state.scenes.isRain);
  const [rainVolume, setRainVolume] = useState<number>(50);
  const handleChangeSceneStatus = () => {
    setChecked(!checked);
    dispatch(setStatusScene());
  };
  const handleCheckFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      setIsFullScreen(false);
    } else {
      document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    }
  };

  const handleSetStatusRain = () => {
    dispatch(setRain());
  };
  React.useEffect(() => {
    if (isRain) {
      audioRef.current?.play();
    } else {
      audioRef.current?.pause();
    }
  }, [isRain]);
  const handleChangeRainVolume = (
    event: Event,
    newValue: number | number[]
  ) => {
    setRainVolume(newValue as number);
    if (audioRef.current) {
      audioRef.current.volume = (newValue as number) / 100;
    }
  };

  const formatTime: string = date.toLocaleTimeString("en-us", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <StyledHeader className="h-20  z-50 flex justify-between items-center px-12 fixed w-full">
      <div className="relative w-[170px] max-w-[150px]  max-h-[150px]">
        <img
          className="w-full h-full align-middle border-none"
          src={IMAGE_SRC.LOGO}
          alt=""
        />
      </div>
      <div className="flex items-center gap-x-4">
        <div className="flex items-center gap-x-4">
          <span className="bg-[#121212bf] whitespace-nowrap cursor-pointer  px-2 py-[6px] rounded-md font-medium text-white flex justify-center items-center text-sm">
            {formatTime}
          </span>
          <Switch onChange={handleChangeSceneStatus} />
          <div className="relative rain-status cursor-pointer select-none">
            <div onClick={handleSetStatusRain} className="relative">
              {isRain && !currentScene.primeum && (
                <i className="bi text-primary  text-3xl transition-all hover:text-primary  bi-cloud-lightning-rain"></i>
              )}
              {!isRain && !currentScene.primeum && (
                <i className="bi text-white text-3xl transition-all hover:text-primary  bi-cloud"></i>
              )}
            </div>
            {isRain && (
              <Stack
                className="absolute invisible opacity-0  rain-track w-[100px] "
                spacing={2}
                direction="row"
                sx={{ mb: 1 }}
                alignItems="center"
              >
                <Slider
                  value={rainVolume}
                  onChange={handleChangeRainVolume}
                  className="rain-volume"
                  defaultValue={30}
                  aria-label="Disabled slider"
                />
              </Stack>
            )}
          </div>
          {/* {!isFullScreen && (
            <div className="relative cursor-pointer select-none">
              <img className="text-sm h-12" src={Icons.premium} alt="" />
            </div>
          )} */}
        </div>
        <div className="flex items-center gap-x-4">
          <Control />
          <div
            onClick={handleCheckFullScreen}
            className="full-screen cursor-pointer"
          >
            <img className=" w-7 h-7" src={Icons.fulscreen} alt="" />
          </div>
          <div className="full-screen dropdown-option relative cursor-pointer">
            <div
              onClick={() => setShowDropdown(!showDropdown)}
              className="menu-dropdown"
            >
              <img className="w-7 h-7" src={Icons.menu} alt="" />
            </div>
            <Dropdown show={showDropdown} setShow={setShowDropdown} />
          </div>
        </div>
      </div>
      <audio
        id="audio-sound"
        loop
        ref={audioRef}
        src={soundSrc.rainSound}
      ></audio>
    </StyledHeader>
  );
};

export default memo(Header);
const StyledHeader = styled.div`
  & .rain-volume {
    height: 10px;
    color: #f3a952;
  }
  & .rain-btn:hover .rain-track {
    opacity: 1;
    visibility: visible;
  }
  .rain-status:hover .rain-track {
    opacity: 1;
    visibility: visible;
  }
  .dropdown-option:hover .dropdown-menu {
    visibility: visible;
    opacity: 1;
  }
`;
